import { render, staticRenderFns } from "./ReportPatient.vue?vue&type=template&id=66d41ccb&scoped=true&"
import script from "./ReportPatient.vue?vue&type=script&lang=js&"
export * from "./ReportPatient.vue?vue&type=script&lang=js&"
import style0 from "./ReportPatient.vue?vue&type=style&index=0&id=66d41ccb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d41ccb",
  null
  
)

export default component.exports